import type { CustomFieldValue, ProjectNode } from '@/shared/types/projectData';
import { getNodeCustomField } from '@/features/editor/documentCustomFields';

export type ReportBody = { content: string; blocks: CustomFieldValue[] | null };

export const readReportBody = (node: Partial<ProjectNode>): ReportBody => {
  const blocks = getNodeCustomField(node as ProjectNode, 'reportBlockDocument', 'report_block_document');
  return {
    content: typeof node.content === 'string' ? node.content : typeof node.description === 'string' ? node.description : '',
    blocks: Array.isArray(blocks) ? blocks : null,
  };
};

export const isReportBody = (value: unknown): value is ReportBody => Boolean(
  value && typeof value === 'object' && 'content' in value && typeof value.content === 'string'
  && 'blocks' in value && (value.blocks === null || Array.isArray(value.blocks)),
);
